/**
 * this function only used in utils, if you want to use it outside, please export it from `index.js`.
 */
const  { QuotationWebSocket }  = require('./quotationWebsocket.js')
const config = require('../api/config')
class Socket {
    init(cb = function() {}) {
            if (!this.websocket) {
                this.websocket = new QuotationWebSocket(config.baseWebSocket, 'sinaQuotation') // 'ws://test-quotes.fdzq.com:18886/quote'  config.baseWebSocket
                    // this.websocket = {}
                    // 打开log
                    // this.websocket.openLog()
                    // 打开自动重新连接，但它并不会在一开始没连接时主动连接
                this.websocket.autoReconnect()

                this.websocket.on(QuotationWebSocket.EVENT.onOpen, () => {
                    console.log('WebSocket连接已打开！')
                    cb()
                })
                this.websocket.on(QuotationWebSocket.EVENT.onClose, () => {
                    console.log('WebSocket 已关闭！')
                })
                this.websocket.on(QuotationWebSocket.EVENT.onError, () => {
                        console.log('WebSocket连接打开失败，请检查！')
                    })
                    // 开始链接
                this.websocket.connect()
            }
        }
        // 关闭链接
    closeSocket() {
        try {
            console.log('------- ', this.websocket)
            this.websocket.close()
        } catch (error) {
            console.log(error)
        }
    }
}

var ws = new Socket()
ws.init()
module.exports = {
    Socket,
    ws
}
